import React from 'react'

const About = () => {
  return (
    <React.Fragment>
      <h1>About This App</h1>
      <p>App to search GitHub users</p>
      <p>Version: 1.0.0</p>
    </React.Fragment>
  )
}

export default About
